/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { EntityVersion, ID, WithDirtyType } from '@gh/common-shared-data';
import { createEnum, EnumSet } from '@gh/core-data';
import { UserStatus } from '../users/user-status.enum';

export const SalespersonBudgetType = createEnum('SALESPERSON_BUDGETS_TYPE', {
  Leads: 1,
  Sales: 2,
});

export type SalespersonBudgetType = EnumSet<typeof SalespersonBudgetType>;

export type SalespersonBudgetListItemDto = WithDirtyType<{
  salespersonBudgetId: ID;
  salespersonName: string;
  salespersonId: ID;
  status: UserStatus;
  budgetByMonth: number[];
  budgetYear: number;
  budgetType: SalespersonBudgetType;
  version?: EntityVersion;
}>;
